import type { SVGProps } from "react";

export const ElectricBoltIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11 21H9L10 13H6L13 3H15L14 11H18L11 21Z" />
    </svg>
  );
};
